// AI Menu Import texts (Arabic uses قائمة الطعام / قوائم الطعام).

const ar = {
  action: "استيراد قائمة الطعام بالذكاء الاصطناعي",
  actionShort: "استيراد بالذكاء الاصطناعي",
  uploadTitle: "استيراد قائمة الطعام بالذكاء الاصطناعي",
  uploadHint: "ارفع صورة أو ملف PDF أو Excel لقائمة الطعام الحالية. سيحللها الذكاء الاصطناعي ويجهز مسودة للمراجعة، ولن يتغير أي شيء في قوائم الطعام قبل موافقتك.",
  chooseFile: "اختر ملفاً",
  replaceFile: "تغيير الملف",
  dropHere: "اسحب الملف هنا أو اختره",
  accepted: (mb) => `JPG أو PNG أو WEBP أو PDF أو XLSX أو CSV، بحد أقصى ${mb} ميجابايت`,
  intent: "ماذا تريد أن تفعل؟",
  modes: { new_menu: "إنشاء قائمة طعام جديدة", add_to_menu: "إضافة إلى قائمة طعام موجودة", update_menu: "تحديث قائمة طعام موجودة" },
  modeHints: {
    new_menu: "تُنشأ قائمة طعام جديدة كمسودة بعد الموافقة.",
    add_to_menu: "تُضاف الأصناف الجديدة إلى قائمة الطعام المختارة، ويُتعرّف على الأصناف الموجودة مسبقاً.",
    update_menu: "تُطابق الأصناف مع الموجودة وتُحدّث الأسعار والبيانات، وما لم يُذكر يبقى كما هو.",
  },
  targetMenu: "قائمة الطعام",
  selectMenu: "اختر قائمة الطعام",
  menuName: "اسم قائمة الطعام الجديدة",
  upload: "رفع وتحليل",
  cancel: "إلغاء",
  close: "إغلاق",
  notConfigured: "الاستيراد بالذكاء الاصطناعي غير مفعّل على الخادم حالياً.",
  fileTooLarge: (mb) => `الملف أكبر من ${mb} ميجابايت.`,
  fileUnsupported: "نوع الملف غير مدعوم.",
  alreadyUploaded: "هذا الملف قيد الاستيراد بالفعل، فتحنا المسودة الحالية.",

  draftsTitle: "مسودات الاستيراد بالذكاء الاصطناعي",
  status: { uploading: "جارٍ الرفع", uploaded: "في الانتظار", processing: "جارٍ التحليل", needs_review: "بحاجة لمراجعة", approving: "جارٍ الاعتماد", approved: "معتمدة", archived: "مؤرشفة", failed: "فشل" },
  stages: { queued: "في قائمة الانتظار", extracting: "قراءة الملف", understanding: "فهم قائمة الطعام", enriching: "إكمال البيانات", reviewing: "تجهيز المراجعة" },
  review: "مراجعة",
  retry: "إعادة المحاولة",
  archive: "أرشفة",
  openMenu: "فتح قائمة الطعام",
  uploadedBy: (name) => `رفعها ${name}`,

  reviewTitle: "مراجعة مسودة الذكاء الاصطناعي",
  source: "الملف الأصلي",
  draft: "مسودة الذكاء الاصطناعي",
  showSource: "عرض الملف الأصلي",
  showDraft: "عرض المسودة",
  loadingSource: "جارٍ تحميل الملف...",
  sourceUnavailable: "تعذر عرض الملف الأصلي.",
  sheet: "ورقة",
  processingNote: "يحلل الذكاء الاصطناعي الملف الآن. يمكنك إغلاق هذه النافذة والعودة لاحقاً.",
  failedTitle: "تعذر تحليل الملف",
  archivedNote: "هذه المسودة مؤرشفة.",
  approvedNote: "اعتُمدت هذه المسودة وأُضيفت إلى قائمة الطعام.",

  summaryDetected: (s) => `${s.items} صنفاً · ${s.sections} أقسام · ${s.additions} مجموعات إضافات`,
  aiAdded: "أضافها الذكاء الاصطناعي",
  aiAddedParts: {
    sections: (n) => `${n} أقسام`,
    descriptions: (n) => `${n} أوصاف`,
    translations: (n) => `${n} ترجمات`,
    calories: (n) => `${n} تقديرات سعرات`,
    allergens: (n) => `${n} تلميحات حساسية`,
    relationships: (n) => `${n} روابط إضافات`,
  },
  needsVerification: (n) => `${n} حقول تحتاج تحقق`,
  possibleDuplicates: (n) => `${n} تكرارات محتملة`,
  unresolvedPrices: (n) => `${n} أسعار غير محددة`,
  blockingTitle: "يجب حلها قبل الاعتماد",

  filters: { all: "الكل", extracted: "من الملف", ai: "أضافها الذكاء الاصطناعي", verify: "بحاجة لتحقق", low: "ثقة منخفضة", duplicates: "تكرارات محتملة", additions: "الإضافات", excluded: "مستبعدة" },
  noMatches: "لا توجد عناصر مطابقة لهذا الفلتر.",
  provenance: { EXTRACTED: "من الملف", AI_INFERRED: "استنتاج الذكاء الاصطناعي", AI_SUGGESTED: "اقتراح الذكاء الاصطناعي", USER_VERIFIED: "تم التحقق" },
  confidence: (p) => `ثقة ${p}%`,
  needsCheck: "يحتاج تحقق",
  aiValue: (v) => `اقتراح الذكاء الاصطناعي: ${v}`,
  fields: { nameAr: "الاسم (عربي)", nameEn: "الاسم (إنجليزي)", descriptionAr: "الوصف (عربي)", descriptionEn: "الوصف (إنجليزي)", price: "السعر", calories: "السعرات", allergens: "مسببات الحساسية", section: "القسم", title: "العنوان", optionPrice: "سعر الخيار", min: "الحد الأدنى", max: "الحد الأعلى", mandatory: "إلزامي" },
  kcal: "سعرة",
  sar: "ر.س",
  discountFrom: (price) => `بدلاً من ${price}`,
  likely: "محتملة",
  possible: "قد يحتوي على",
  noAllergens: "لا توجد",
  edit: "تعديل",
  save: "حفظ",
  accept: "قبول",
  reject: "رفض",
  verify: "تأكيد",
  empty: "—",
  include: "تضمين",
  exclude: "استبعاد",
  excluded: "مستبعد",
  sourceText: "النص في الملف",
  ambiguity: "ملاحظة",
  acceptTranslations: "قبول كل الترجمات",
  acceptDescriptions: "قبول كل الأوصاف",
  bulkNote: "القبول الجماعي يشمل النصوص فقط. الأسعار والسعرات ومسببات الحساسية تُراجع صنفاً صنفاً.",
  issues: {
    PRICE_UNRESOLVED: "السعر غير محدد",
    PRICE_NEEDS_VERIFICATION: "تحقق من السعر",
    PRICE_NOT_IN_SOURCE: "السعر غير موجود في الملف",
    SIZE_PRICES_UNRESOLVED: "أسعار الأحجام غير واضحة",
    "CALORIES_NEEDS_VERIFICATION": "السعرات تقديرية",
    "ALLERGENS_NEEDS_VERIFICATION": "الحساسية تلميح",
    NEEDS_VERIFICATION: "يحتاج تحقق",
    LOW_CONFIDENCE: "ثقة منخفضة",
    DUPLICATE_PENDING: "تكرار محتمل",
    NAME_REQUIRED: "الاسم مطلوب",
    OPTION_PRICE_UNRESOLVED: "سعر خيار غير محدد",
    OPTION_PRICE_NEEDS_VERIFICATION: "تحقق من أسعار الخيارات",
    SELECTION_RULES_INVALID: "قواعد الاختيار غير صحيحة",
    OPTIONS_REQUIRED: "لا توجد خيارات",
    OPTION_NAME_REQUIRED: "اسم خيار مطلوب",
    TARGET_REQUIRED: "اختر العنصر الموجود",
  },
  duplicate: {
    title: "يشبه عنصراً موجوداً",
    strong: "تطابق قوي",
    possible: "تطابق محتمل",
    decisions: { create: "إنشاء جديد", reuse: "استخدام الموجود", update: "تحديث الموجود", ignore: "تجاهل الاقتراح" },
    pick: "اختر القرار",
    target: "العنصر الموجود",
    score: (p) => `${p}% تشابه`,
  },
  sectionDecision: { create: "قسم جديد", reuse: "إضافة إلى قسم موجود" },
  inferredSection: "قسم استنتجه الذكاء الاصطناعي",
  additionKinds: { size: "الأحجام", choice: "اختيار", extra: "إضافات" },
  linkedItems: "الأصناف المرتبطة",
  linkReason: "السبب",
  acceptAllLinks: "قبول كل الروابط المقترحة",
  rejectAllLinks: "رفض كل الروابط المقترحة",
  linkStatus: { proposed: "مقترح", accepted: "مقبول", rejected: "مرفوض" },
  linkApplies: "سيُطبّق",
  linkSkipped: "لن يُطبّق دون قبولك",
  addLink: "ربط بصنف",
  selectItem: "اختر صنفاً",
  noLinks: "غير مرتبطة بأي صنف.",
  warningsTitle: "ملاحظات التحليل",
  modelInfo: (model) => `النموذج: ${model}`,

  reviewPlan: "مراجعة الاعتماد",
  planTitle: "ما الذي سيتغير عند الاعتماد",
  loadingPlan: "جارٍ تجهيز الملخص...",
  created: "سيُنشأ",
  changed: "سيتغير",
  reused: "سيُستخدم الموجود",
  unchanged: "سيبقى دون تغيير",
  excludedCount: "مستبعد",
  planCounts: {
    sections: (n) => `${n} أقسام`,
    items: (n) => `${n} أصناف`,
    additions: (n) => `${n} مجموعات إضافات`,
  },
  planMenuNew: (name) => `قائمة طعام جديدة (مسودة): ${name}`,
  planMenuExisting: (name) => `قائمة الطعام: ${name}`,
  omitted: (c, a) => `لن تُنشر ${c} تقديرات سعرات و${a} تلميحات حساسية لأنها لم تُؤكد.`,
  aiText: (n) => `${n} نصوص (ترجمات وأوصاف) كتبها الذكاء الاصطناعي ستُنشر كما راجعتها.`,
  skippedLinks: (n) => `${n} روابط إضافات منخفضة الثقة لن تُطبق دون قبولك.`,
  approve: "اعتماد الاستيراد",
  approving: "جارٍ الاعتماد...",
  approvedDone: (items) => `اعتُمد الاستيراد: ${items} أصناف جديدة.`,
  archiveConfirm: "أرشفة هذه المسودة؟ لن يتغير شيء في قوائم الطعام.",
  changedFields: { name: "الاسم", description: "الوصف", pricing: "السعر", calories: "السعرات", allergens: "الحساسية", additionGroups: "الإضافات" },
  // Approve All: confirm every remaining entry and approve in one step.
  approveAll: {
    button: "اعتماد الكل",
    title: "اعتماد كل المحتوى المتبقي؟",
    intro: "سيتم اعتماد كل الأصناف والأقسام المعلّقة بآخر قيمها. العناصر المرفوضة تبقى مرفوضة.",
    loading: "جارٍ تجهيز الملخص…",
    willApprove: (n) => `سيتم اعتماد ${n} عنصر.`,
    edited: (n) => `${n} عنصر معدّل سيُعتمد بالقيم المحدّثة.`,
    already: (n) => `${n} عنصر معتمد مسبقاً سيبقى كما هو.`,
    rejected: (n) => `${n} عنصر مرفوض سيبقى مستبعداً.`,
    sections: (n) => `ضمن ${n} قسم.`,
    prices: (n) => `سيتم تأكيد ${n} سعر كما يظهر في المراجعة.`,
    health: (calories, allergens) => `سيتم اعتماد ونشر ${[calories && `${calories} قيمة سعرات`, allergens && `${allergens} قيمة مسببات حساسية`].filter(Boolean).join(" و")} كما تظهر في المراجعة.`,
    blockedTitle: "تحتاج هذه العناصر إلى إدخالك أولاً",
    nothing: "لا يوجد ما يمكن اعتماده.",
    confirm: "اعتماد الكل",
    working: "جارٍ الاعتماد…",
    done: (approved, rejected) => `تم اعتماد ${approved} عنصر · ${rejected} مرفوض`,
    openMenu: "فتح قائمة الطعام",
  },
  errors: {
    DRAFT_CHANGED: "تغيرت المسودة، تم تحديثها. راجع التغييرات ثم حاول مرة أخرى.",
    APPROVAL_BLOCKED: "هناك مشكلات يجب حلها قبل الاعتماد.",
    APPROVAL_IN_PROGRESS: "يتم اعتماد هذه المسودة الآن.",
    NOTHING_TO_APPROVE: "لا يوجد ما يمكن اعتماده.",
    MENU_NAME_TAKEN: "يوجد قائمة طعام بنفس الاسم. غيّر الاسم ثم أعد المحاولة.",
    MENU_CHANGED: "تغيرت قائمة الطعام منذ المراجعة. راجع الخطة مرة أخرى.",
    TOO_MANY_ACTIVE_IMPORTS: "هناك عدة استيرادات قيد التحليل لهذا المطعم. انتظر حتى تنتهي.",
    AI_NOT_CONFIGURED: "الاستيراد بالذكاء الاصطناعي غير مفعّل على الخادم حالياً.",
  },
};

const en = {
  action: "AI Menu Import",
  actionShort: "AI import",
  uploadTitle: "AI Menu Import",
  uploadHint: "Upload an image, PDF or Excel file of an existing menu. AI analyzes it and prepares a draft for review. Nothing changes in your menus until you approve.",
  chooseFile: "Choose a file",
  replaceFile: "Change file",
  dropHere: "Drop the file here or choose it",
  accepted: (mb) => `JPG, PNG, WEBP, PDF, XLSX or CSV, up to ${mb} MB`,
  intent: "What do you want to do?",
  modes: { new_menu: "Create new menu", add_to_menu: "Add to existing menu", update_menu: "Update existing menu" },
  modeHints: {
    new_menu: "A new menu is created as a draft after approval.",
    add_to_menu: "New items are added to the chosen menu; items it already has are recognized.",
    update_menu: "Items are matched with existing ones and prices/details updated; anything not mentioned stays as it is.",
  },
  targetMenu: "Menu",
  selectMenu: "Select a menu",
  menuName: "New menu name",
  upload: "Upload and analyze",
  cancel: "Cancel",
  close: "Close",
  notConfigured: "AI menu import is not configured on the server.",
  fileTooLarge: (mb) => `The file is larger than ${mb} MB.`,
  fileUnsupported: "This file type is not supported.",
  alreadyUploaded: "This file is already being imported; the existing draft was opened.",

  draftsTitle: "AI import drafts",
  status: { uploading: "Uploading", uploaded: "Queued", processing: "Processing", needs_review: "Needs review", approving: "Approving", approved: "Approved", archived: "Archived", failed: "Failed" },
  stages: { queued: "Queued", extracting: "Reading the file", understanding: "Understanding the menu", enriching: "Completing details", reviewing: "Preparing review" },
  review: "Review",
  retry: "Retry",
  archive: "Archive",
  openMenu: "Open menu",
  uploadedBy: (name) => `Uploaded by ${name}`,

  reviewTitle: "Review AI draft",
  source: "Original source",
  draft: "AI draft",
  showSource: "Show original",
  showDraft: "Show draft",
  loadingSource: "Loading the file...",
  sourceUnavailable: "The original file could not be shown.",
  sheet: "Sheet",
  processingNote: "AI is analyzing the file. You can close this window and come back later.",
  failedTitle: "The file could not be analyzed",
  archivedNote: "This draft is archived.",
  approvedNote: "This draft was approved and added to the menu.",

  summaryDetected: (s) => `${s.items} items · ${s.sections} sections · ${s.additions} addition groups detected`,
  aiAdded: "AI added",
  aiAddedParts: {
    sections: (n) => `${n} sections`,
    descriptions: (n) => `${n} descriptions`,
    translations: (n) => `${n} translations`,
    calories: (n) => `${n} calorie estimates`,
    allergens: (n) => `${n} allergen hints`,
    relationships: (n) => `${n} addition relationships`,
  },
  needsVerification: (n) => `${n} fields need verification`,
  possibleDuplicates: (n) => `${n} possible duplicates`,
  unresolvedPrices: (n) => `${n} unresolved prices`,
  blockingTitle: "Resolve before approving",

  filters: { all: "All", extracted: "Extracted", ai: "AI added", verify: "Needs verification", low: "Low confidence", duplicates: "Possible duplicates", additions: "Additions", excluded: "Excluded" },
  noMatches: "Nothing matches this filter.",
  provenance: { EXTRACTED: "From source", AI_INFERRED: "AI inferred", AI_SUGGESTED: "AI suggested", USER_VERIFIED: "User verified" },
  confidence: (p) => `${p}% confidence`,
  needsCheck: "Needs verification",
  aiValue: (v) => `AI suggested: ${v}`,
  fields: { nameAr: "Name (Arabic)", nameEn: "Name (English)", descriptionAr: "Description (Arabic)", descriptionEn: "Description (English)", price: "Price", calories: "Calories", allergens: "Allergens", section: "Section", title: "Title", optionPrice: "Option price", min: "Min", max: "Max", mandatory: "Mandatory" },
  kcal: "kcal",
  sar: "SAR",
  discountFrom: (price) => `was ${price}`,
  likely: "Likely",
  possible: "May contain",
  noAllergens: "None",
  edit: "Edit",
  save: "Save",
  accept: "Accept",
  reject: "Reject",
  verify: "Mark verified",
  empty: "—",
  include: "Include",
  exclude: "Exclude",
  excluded: "Excluded",
  sourceText: "Source text",
  ambiguity: "Note",
  acceptTranslations: "Accept all translations",
  acceptDescriptions: "Accept all descriptions",
  bulkNote: "Bulk accept covers text only. Prices, calories and allergens are reviewed item by item.",
  issues: {
    PRICE_UNRESOLVED: "Price unresolved",
    PRICE_NEEDS_VERIFICATION: "Check the price",
    PRICE_NOT_IN_SOURCE: "Price not found in source",
    SIZE_PRICES_UNRESOLVED: "Size prices unclear",
    CALORIES_NEEDS_VERIFICATION: "Calories are an estimate",
    ALLERGENS_NEEDS_VERIFICATION: "Allergens are hints",
    NEEDS_VERIFICATION: "Needs verification",
    LOW_CONFIDENCE: "Low confidence",
    DUPLICATE_PENDING: "Possible duplicate",
    NAME_REQUIRED: "Name required",
    OPTION_PRICE_UNRESOLVED: "Option price unresolved",
    OPTION_PRICE_NEEDS_VERIFICATION: "Check option prices",
    SELECTION_RULES_INVALID: "Invalid selection rules",
    OPTIONS_REQUIRED: "No options",
    OPTION_NAME_REQUIRED: "Option name required",
    TARGET_REQUIRED: "Choose the existing entry",
  },
  duplicate: {
    title: "Looks like an existing entry",
    strong: "Strong match",
    possible: "Possible match",
    decisions: { create: "Create new", reuse: "Reuse existing", update: "Replace / update", ignore: "Ignore suggestion" },
    pick: "Choose a decision",
    target: "Existing entry",
    score: (p) => `${p}% similar`,
  },
  sectionDecision: { create: "New section", reuse: "Add to existing section" },
  inferredSection: "Section inferred by AI",
  additionKinds: { size: "Sizes", choice: "Choice", extra: "Extras" },
  linkedItems: "Linked items",
  linkReason: "Why",
  acceptAllLinks: "Accept all suggested links",
  rejectAllLinks: "Reject all suggested links",
  linkStatus: { proposed: "Suggested", accepted: "Accepted", rejected: "Rejected" },
  linkApplies: "Will be applied",
  linkSkipped: "Not applied unless accepted",
  addLink: "Link to item",
  selectItem: "Select an item",
  noLinks: "Not linked to any item.",
  warningsTitle: "Analysis notes",
  modelInfo: (model) => `Model: ${model}`,

  reviewPlan: "Review approval",
  planTitle: "What approval will change",
  loadingPlan: "Preparing the summary...",
  created: "Created",
  changed: "Changed",
  reused: "Reused",
  unchanged: "Left unchanged",
  excludedCount: "Excluded",
  planCounts: {
    sections: (n) => `${n} sections`,
    items: (n) => `${n} items`,
    additions: (n) => `${n} addition groups`,
  },
  planMenuNew: (name) => `New menu (draft): ${name}`,
  planMenuExisting: (name) => `Menu: ${name}`,
  omitted: (c, a) => `${c} calorie estimates and ${a} allergen hints will NOT be published because they were not verified.`,
  aiText: (n) => `${n} AI-written texts (translations, descriptions) will be published as reviewed.`,
  skippedLinks: (n) => `${n} low-confidence addition links will not be applied unless you accept them.`,
  approve: "Approve import",
  approving: "Approving...",
  approvedDone: (items) => `Import approved: ${items} new items.`,
  archiveConfirm: "Archive this draft? Nothing changes in your menus.",
  changedFields: { name: "name", description: "description", pricing: "price", calories: "calories", allergens: "allergens", additionGroups: "additions" },
  // Approve All: confirm every remaining entry and approve in one step.
  approveAll: {
    button: "Approve All",
    title: "Approve all remaining imported content?",
    intro: "This will approve all pending items and sections using their latest values. Rejected entries will remain rejected.",
    loading: "Preparing the summary…",
    willApprove: (n) => `${n} ${n === 1 ? "entry" : "entries"} will be approved.`,
    edited: (n) => `${n} edited ${n === 1 ? "entry" : "entries"} will be approved using the updated values.`,
    already: (n) => `${n} already approved ${n === 1 ? "entry stays" : "entries stay"} as ${n === 1 ? "it is" : "they are"}.`,
    rejected: (n) => `${n} rejected ${n === 1 ? "entry" : "entries"} will remain excluded.`,
    sections: (n) => `In ${n} ${n === 1 ? "section" : "sections"}.`,
    prices: (n) => `${n} ${n === 1 ? "price" : "prices"} will be confirmed as shown in the review.`,
    health: (calories, allergens) => `${[calories && `${calories} calorie`, allergens && `${allergens} allergen`].filter(Boolean).join(" and ")} ${calories + allergens === 1 ? "value" : "values"} will be approved and published as shown in the review.`,
    blockedTitle: "These need your input first",
    nothing: "There is nothing left to approve.",
    confirm: "Approve All",
    working: "Approving…",
    done: (approved, rejected) => `${approved} ${approved === 1 ? "entry" : "entries"} approved · ${rejected} rejected`,
    openMenu: "Open menu",
  },
  errors: {
    DRAFT_CHANGED: "The draft changed and was reloaded. Check it and try again.",
    APPROVAL_BLOCKED: "Some problems must be resolved before approving.",
    APPROVAL_IN_PROGRESS: "This draft is being approved right now.",
    NOTHING_TO_APPROVE: "There is nothing left to approve.",
    MENU_NAME_TAKEN: "A menu with this name already exists. Change the name and try again.",
    MENU_CHANGED: "The menu changed since the review. Review the plan again.",
    TOO_MANY_ACTIVE_IMPORTS: "Several imports are being processed for this restaurant. Wait for them to finish.",
    AI_NOT_CONFIGURED: "AI menu import is not configured on the server.",
  },
};

export const aiImportText = (lang) => (lang === "ar" ? ar : en);
